<div class="search-input-container">
    <div class="input-group">
        <div
            *ngIf="searchControl"
            class="textarea search-input-scroll"
            [formControl]="searchControl"
            name="searchControl"
            ngDefaultControl
            data-gramm="false"
            contenteditable="true"
            aria-label="Search prompt"
            [attr.placeholder]="placeholder"
            (keyup)="onKeySearchText($event)"
            (paste)="onPaste($event)"
        ></div>

        <div class="send-container">
            <div class="send" *ngIf="isTyping">
                <button type="button" class="search-button" (click)="chat($event)">
                    <img src="/assets/icons/send.svg" alt="Send" />
                </button>
            </div>
            <div class="send" *ngIf="!isTyping">
                <button (click)="pause($event)" class="search-button">
                    <img src="/assets/icons/icon-stop-24.svg" alt="Stop" />
                </button>
            </div>
            <div class="line"></div>
            <button
                type="button"
                (click)="reset()"
                class="send search-button"
                [aidaTooltip]="'Start over'"
                aidaTooltipPosition="bottom"
                aria-label="Start over"
            >
                <img src="../../../../assets/icons/plus.svg" alt="" />
            </button>
        </div>

        <button *ngIf="!isSearch" (click)="toggleFilters()" class="search-button">
            <img src="../../../../assets/icons/filter.svg" alt="" />
        </button>
    </div>
</div>

<div class="filter-container" *ngIf="!isSearch && showFilters">
    <div class="select-container">
        <ng-container *ngFor="let filter of filterAttributes">
            <div class="select">
                <mapp-multiselect
                    id="{{ 'filterSelect' + filter.name }}"
                    [filter]="filter"
                    [isMultiselect]="filter.multiselect"
                    [(selectedValues)]="selectedFilters[filter.fieldName]"
                    (selectedValuesChange)="setSelectedFiltersValues()"
                ></mapp-multiselect>
            </div>
        </ng-container>
    </div>
    <div class="buttons-container">
        <button (click)="clearFilters()" class="clear-filter-button">Clear all</button>
    </div>
</div>
